module.exports = __webpack_public_path__ + "img/pending-check.7884d86b.svg";